import { serializeTokens } from './tokens'
import { SerializedFarmConfig } from './types'

const serializedTokens = serializeTokens()

const farms: SerializedFarmConfig[] = [
  /**
   * These 3 farms (PID 0, 251, 252) should always be at the top of the file.
   */
   {
    pid: 0,
    lpSymbol: 'ASCS',
    lpAddresses: {
      97: '0x9C21123D94b93361a29B2C2EFB3d5CD8B17e0A9e',
      92522: '0xD5acd23946457cb62AC410bFaC795c0c9218E381',
    },
    token: serializedTokens.syrup,
    quoteToken: serializedTokens.wbnb,
  } 
  ,
  {
    pid: 1,
    lpSymbol: 'ASCS-ASC LP',
    lpAddresses: {
      97: '0x3ed8936cAFDF85cfDBa29Fbe5940A5b0524824F4',
      92522: '0x2e25A02aecb8b7345B270aFFc509aAE663e5E450',
    },
    token: serializedTokens.cake,
    quoteToken: serializedTokens.wbnb,
  },
  {
    pid: 2,
    lpSymbol: 'AST-ASC LP',
    lpAddresses: {
      97: '',
      92522: '0x41c204fE3EF99C8eb00995b94d61dafDdDD81525',
    },
    token: serializedTokens.busd,
    quoteToken: serializedTokens.wbnb,
  }
  
]

export default farms
